import { render, staticRenderFns } from "./PrivatePolicy.vue?vue&type=template&id=a15bfade&scoped=true"
import script from "./PrivatePolicy.vue?vue&type=script&lang=js"
export * from "./PrivatePolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivatePolicy.vue?vue&type=style&index=0&id=a15bfade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15bfade",
  null
  
)

export default component.exports